import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import ChatWidget from "./ChatWidget";

export default function Layout({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-[#F9F9F7] text-[#1C1C1C]">
            <Header />
            <main className="flex-1 pt-20" data-testid="site-main">
                {children}
            </main>
            <Footer />
            <ChatWidget />
        </div>
    );
}
